import React from 'react';
import styled from 'styled-components';
import { Container } from '@nfs-react/components';
import { useImg, useText } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';
import { ChangeableBackgroundSection } from 'helpers/components';

const Features = () => {
  const IconItems = [
    {
      img: 'feat_1.webp',
      text: 'join_icon1',
    },
    {
      img: 'feat_2.webp',
      text: 'join_icon2',
    },
    {
      img: 'feat_3.webp',
      text: 'join_icon3',
    },
    {
      img: 'feat_4.webp',
      text: 'join_icon4',
    },
  ];

  return (
    <ChangeableBackgroundSection
      id="features-background"
      defaultStyle={{ backgroundColor: '#fff' }}
    >
      <Wrapper>
        <FeatureContainer>
          <Title>{useText('join_title', true)}</Title>
          <IconList>
            {IconItems.map(({ img, text }, i) => (
              <IconItem key={i}>
                <IconImage>{useImg(img)}</IconImage>
                <IconText>{useText(text, true)}</IconText>
              </IconItem>
            ))}
          </IconList>
        </FeatureContainer>
      </Wrapper>
    </ChangeableBackgroundSection>
  );
};

const Wrapper = styled.div`
  position: relative;

  @media ${DESKTOP} {
    padding: 0 0 30px;
  }

  @media ${MOBILE} {
    padding: 52px 0 20px;
  }
`;

const FeatureContainer = styled(Container)`
  padding: 0 40px;

  @media ${TABLET} {
    padding: 0 40px;
    max-width: 750px;
  }

  @media ${MOBILE} {
    padding: 0 40px;
    max-width: 750px;
  }
`;

const Title = styled.div`
  margin-bottom: 36px;

  h3 {
    margin: 0;
    color: #313131;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }

  @media ${DESKTOP} {

  }

  @media ${TABLET} {
    text-align: center;
  }

  @media ${MOBILE} {
    text-align: center;
    margin-bottom: 26px;

    h3 {
      margin: 0;
      font-size: 16px;
      line-height: 19px;
    }
  }
`;

const IconList = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 auto;

  @media ${TABLET} {
    flex-wrap: wrap;
    gap: 24px;
  }

  @media ${MOBILE} {
    flex-direction: column;
  }
`;

const IconItem = styled.div`
  min-width: 145px;
  max-width: 24%;
  border: 1px solid #e0e0e0;
  background-color: #f2f2f2;
  margin: 0 0 8px;
  padding: 16px 20px 10px;

  @media ${DESKTOP} {

  }

  @media ${TABLET} {
    min-width: 320px;
    max-width: 48%;
    border: 1px solid #e0e0e0;
    background-color: #f2f2f2;
    padding: 16px 20px 10px;
  }

  @media ${MOBILE} {
    flex-direction: column;
    max-width: inherit;
    margin: 0 0 20px;
  }
`;

const IconImage = styled.div`
  @media ${DESKTOP} {
    width: 70px;
    height: 70px;
    margin: 0 auto 10px;
  }

  img {
    display: block;
    margin: auto;
    width: 60px;
  }

  @media ${TABLET} {
    width: 60px;
    height: 60px;
    margin: 0 auto 14px;
  }

  @media ${MOBILE} {
    width: 61px;
    height: 61px;
    margin: 0 auto 12px;
  }

`;

const IconText = styled.div`
  text-align: center;
  color: #363f40;
  @media ${DESKTOP} {
    font-size: 18px;
    line-height: 23px;
  }

  @media ${TABLET} {
    font-size: 16px;
    line-height: 20px;
  }

  @media ${MOBILE} {
    font-size: 18px;
    line-height: 23px;
  }
`;

export default Features;
